import { AutogenLayoutOrderAgentPayee } from "./autogen/AutogenLayoutOrderAgentPayee";

export class OrderAgentPayee extends AutogenLayoutOrderAgentPayee {
}
